export default __webpack_public_path__ + "static/5-0ef34c86342bf4ba21bf0fba1be1bcd0.jpg";